import React from "react";
import "./Seventh.css";
import { Container } from "react-bootstrap";
import analyze from "../../../../Asset/mobileApp/analyze.svg";
import sprint from "../../../../Asset/mobileApp/Sprint-planning.svg";
import build from "../../../../Asset/mobileApp/build.svg";
import review from "../../../../Asset/mobileApp/review.svg";
import test from "../../../../Asset/mobileApp/test.svg";
import iterate from "../../../../Asset/mobileApp/iterate.svg";

const Seventh = () => {
  return (
    <>
      <section className="seventh-mobileApp-section">
        <Container>
          <div className="top-text-after-seventh-services">
            <h2>
              SOFTWARE DEVELOPMENT <span>PROCESS</span>
            </h2>
          </div>
          <div className="row scroll-row">
            <div className="col-xl-5">
              <div className="mob-app-sec-7-wrapper">
                <h3>Our Step-by-Step Process for App Innovation</h3>
                <p>
                  At Codeffi, we build top-notch custom mobile apps by embracing
                  the Agile method. Agile boosts flexibility, transparency, and
                  collaboration, so we can adapt quickly and deliver
                  higher-quality work. Constant client involvement and rapid
                  iterations lead to better satisfaction. Agile allows us to be
                  nimble and responsive, so we can turn app visions into reality
                  reliably and rapidly. This client-focused approach drives us
                  to exceed expectations with every mobile app we
                </p>
              </div>
            </div>
            <div className="col-xl-7">
              <div className="sec-7-scroll-wrapper ">
                <div className="app-innovation-scroll d-flex">
                  <div className="card-img">
                    <img alt="card" src={analyze} className="w-100" />
                  </div>
                  <div className="card-content">
                    <h5>Analyze</h5>
                    <div className="sort-info">
                      In the initial stage, we work closely with clients to
                      deeply understand their vision for the mobile app and
                      identify high-value features and requirements to
                      prioritize. This open collaboration allows us to resonate
                      with their needs.
                    </div>
                  </div>
                </div>
                <div className="app-innovation-scroll d-flex">
                  <div className="card-img">
                    <img alt="card" src={sprint} className="w-100" />
                  </div>
                  <div className="card-content">
                    <h5>Sprint planning</h5>
                    <div className="sort-info">
                      During this stage, Our agile teams strategically plan
                      development sprints that typically range from 2-4 weeks.
                      This provides short cycles to iterate and deliver regular
                      value.
                    </div>
                  </div>
                </div>
                <div className="app-innovation-scroll d-flex">
                  <div className="card-img">
                    <img alt="card" src={build} className="w-100" />
                  </div>
                  <div className="card-content">
                    <h5>Build</h5>
                    <div className="sort-info">
                      Our specialized mobile app developers get to work bringing
                      the planned features to life during each sprint. They use
                      proven practices like pair programming and test-driven
                      development to build high-quality code.
                    </div>
                  </div>
                </div>
                <div className="app-innovation-scroll d-flex">
                  <div className="card-img">
                    <img alt="card" src={review} className="w-100" />
                  </div>
                  <div className="card-content">
                    <h5>Review & Reflect</h5>
                    <div className="sort-info">
                      At the end of each sprint, we conduct a sprint review
                      meeting and retrospection to demonstrate and reflect on
                      the new features and functionality to stakeholders. This
                      helps us continuously improve and optimize how we work.
                    </div>
                  </div>
                </div>
                <div className="app-innovation-scroll d-flex">
                  <div className="card-img">
                    <img alt="card" src={test} className="w-100" />
                  </div>
                  <div className="card-content">
                    <h5>Test & Plan</h5>
                    <div className="sort-info">
                      Testing is woven throughout the entire development
                      process, including unit, integration, and regression
                      testing. During release planning, user stories are
                      prioritized across multiple sprints to determine upcoming
                      releases.
                    </div>
                  </div>
                </div>
                <div className="app-innovation-scroll d-flex">
                  <div className="card-img">
                    <img alt="card" src={iterate} className="w-100" />
                  </div>
                  <div className="card-content">
                    <h5>Iterate</h5>
                    <div className="sort-info">
                      After each sprint, we repeat the cycle, returning to
                      planning for the next sprint. This iterative approach
                      allows for rapid adaptation to evolving needs and
                      continuous delivery of incremental value.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Seventh;
